module.exports = __webpack_public_path__ + "static/media/picture-(85).362b38bc.JPG";